// extracted by mini-css-extract-plugin
export var leadText = "no-search-results-module--leadText--nctKq";
export var link = "no-search-results-module--link--bkrcd";
export var linkIcon = "no-search-results-module--linkIcon--1FC0G";
export var noSearchResults = "no-search-results-module--noSearchResults--pPsw2";
export var text = "no-search-results-module--text--KkuPS";